import React from 'react';
import clsx from 'clsx';

const variantStyles = {
  primary: 'bg-brand text-white hover:bg-brand-dark focus:ring-brand',
  secondary: 'bg-white border border-gray-medium text-gray-text hover:bg-gray-medium focus:ring-gray-medium',
  danger: 'bg-danger text-white hover:bg-danger-dark focus:ring-danger',
};

const sizeStyles = {
  sm: 'text-xs py-1.5 px-3',
  md: 'text-sm py-2 px-4',
};

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  ...props
}) => {
  return (
    <button
      className={clsx(
        'rounded-md font-semibold shadow-sm transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-opacity-50',
        variantStyles[variant],
        sizeStyles[size],
        className
      )}
      {...props}
    >
      {children}
    </button>
  );

};

export default Button;